import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3573e944"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings p-mt-2" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-fixed setting" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idLicenseFile" }, "Upload license file", -1))
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "p-field p-col-fixed setting" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idRootPassword" }, "'root' Password", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Leave empty for unchanged password.", -1))
const _hoisted_9 = { class: "p-field p-col-fixed setting" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idRootPasswordRepeat" }, " ", -1))
const _hoisted_11 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_12 = { class: "p-field p-col-fixed setting" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idStatusPassword" }, "'status' Password", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Leave empty for unchanged password.", -1))
const _hoisted_15 = { class: "p-field p-col-fixed setting" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idStatusPasswordRepeat" }, " ", -1))
const _hoisted_17 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_18 = { class: "p-field p-col-fixed setting" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idStatusPassword" }, "Secret", -1))
const _hoisted_20 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_21 = { class: "p-field p-col-fixed setting" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idSessionTimeout" }, "Session Timeout", -1))
const _hoisted_23 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_24 = { class: "p-field p-col-fixed setting" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "idLogLevel" }, "Level", -1))
const _hoisted_26 = { class: "p-mt-2" }
const _hoisted_27 = { class: "p-d-flex p-mt-2 p-jc-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BlockUI, {
      blocked: _ctx.waitForResponse || !_ctx.validResponse
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Panel, { header: "License file" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_FileUpload, {
                  id: "idLicenseFile",
                  mode: "basic",
                  name: "container",
                  url: "/api/licenses",
                  accept: ".frn",
                  maxFileSize: 1000000,
                  onUpload: _ctx.onFrnUpload,
                  onError: _ctx.onFrnError
                }, null, 8, ["onUpload", "onError"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Panel, {
          class: "p-mt-2",
          header: "Authorization"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Password, {
                  id: "idRootPassword",
                  modelValue: _ctx.rootPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rootPassword) = $event)),
                  toggleMask: ""
                }, null, 8, ["modelValue"]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Password, {
                  id: "idRootPasswordRepeat",
                  modelValue: _ctx.rootPasswordRepeat,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rootPasswordRepeat) = $event)),
                  feedback: false,
                  class: _normalizeClass({ 'p-invalid': !_ctx.isRootPasswordRepeatValid }),
                  toggleMask: ""
                }, null, 8, ["modelValue", "class"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Password, {
                  id: "idStatusPassword",
                  modelValue: _ctx.statusPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.statusPassword) = $event)),
                  toggleMask: ""
                }, null, 8, ["modelValue"]),
                _hoisted_14
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Password, {
                  id: "idStatusPasswordRepeat",
                  modelValue: _ctx.statusPasswordRepeat,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statusPasswordRepeat) = $event)),
                  feedback: false,
                  class: _normalizeClass({ 'p-invalid': !_ctx.isStatusPasswordRepeatValid }),
                  toggleMask: ""
                }, null, 8, ["modelValue", "class"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Panel, {
          class: "p-mt-2",
          header: "Client"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Password, {
                  id: "idClientSecret",
                  modelValue: _ctx.clientSecret,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clientSecret) = $event)),
                  toggleMask: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Panel, {
          class: "p-mt-2",
          header: "HTTP"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createVNode(_component_InputNumber, {
                  id: "idSessionTimeout",
                  modelValue: _ctx.sessionTimeout,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sessionTimeout) = $event)),
                  mode: "decimal",
                  min: 5,
                  max: 65535,
                  useGrouping: false,
                  suffix: " min"
                }, null, 8, ["modelValue"]), [
                  [_directive_tooltip, 'Changing this will restart the server and invalidate all existing sessions.']
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Panel, {
          class: "p-mt-2",
          header: "Log"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Dropdown, {
                  id: "idLogLevel",
                  modelValue: _ctx.logLevel,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.logLevel) = $event)),
                  options: _ctx.logLevels,
                  optionLabel: "label",
                  optionValue: "code"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["blocked"]),
    _createElementVNode("div", _hoisted_26, [
      (_ctx.waitForResponse)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "progress"
          }))
        : (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 1,
            mode: "determinate",
            value: 0,
            showValue: false,
            class: "progress"
          }))
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_Button, {
        label: "Save",
        icon: "pi pi-check",
        onClick: _ctx.saveSettings,
        class: "p-mr-2",
        disabled: _ctx.waitForResponse || !_ctx.validResponse
      }, null, 8, ["onClick", "disabled"]),
      _createVNode(_component_Button, {
        label: "Reset",
        icon: "pi pi-undo",
        onClick: _ctx.getSettings,
        class: "p-mr-2 p-button-warning",
        disabled: _ctx.waitForResponse
      }, null, 8, ["onClick", "disabled"]),
      _createVNode(_component_Button, {
        label: "Restart",
        icon: "pi pi-undo",
        onClick: _ctx.restartBackend,
        class: "p-button-danger",
        disabled: _ctx.waitForResponse
      }, null, 8, ["onClick", "disabled"])
    ])
  ]))
}